import {useEffect, useMemo, useState} from 'react';
import useGeo from '../../hooks/useGeo';
import {useShipping} from '../../hooks/useShipping';
import {useShippingEst} from '../../hooks/useShippingEst';
import {useFreeShippingThreshold} from '../../hooks/useFreeShippingThreshold';
import {useDispatch} from '../../hooks/useDispatch';
import getCountryName from '../../utils/getCountryName';
import {useLocalization} from '@shopify/hydrogen';
import type {Region} from './Layout.server';

type TRegion = {
  isoCode: string;
  name: string;
} | null;

type Props = {
  regions: Region[];
};

// TODO: This is legacy code that needs to be refactored

export default function SetShipping({regions}: Props) {
  //create a single array of countries.isoCode in sanityCountries
  const sanityCountries = useMemo(() => {
    return regions
      .map((region) =>
        region.countries?.map((c) => {
          return c.isoCode.toUpperCase();
        }),
      )
      .flat();
  }, [regions]);

  const setShipping = useShipping();
  const setShippingEst = useShippingEst();
  const setFreeShippingThreshold = useFreeShippingThreshold();
  const setDispatch = useDispatch();
  const [region, setRegion] = useState<TRegion>(null);
  const {
    country: {isoCode},
  } = useLocalization();

  const {preferredCountryCookie} = useGeo();

  useEffect(() => {
    setRegion({
      isoCode: preferredCountryCookie === 'XX' ? 'NZ' : preferredCountryCookie,
      name:
        getCountryName(
          preferredCountryCookie === 'XX' ? 'NZ' : preferredCountryCookie,
        ) || 'New Zealand',
    });

    if (
      !sanityCountries.find((country) => ['NZ', 'AU', 'XX'].includes(country))
    ) {
      setShipping(false);
    }
  }, []);

  useEffect(() => {
    // GET SHIPPING INFO
    // get the item from countries.countries that matches the currentCountry
    const country = regions?.find((c) => {
      return c?.countries?.find((i) => {
        return i?.isoCode?.toUpperCase() === isoCode?.toUpperCase();
      });
    });
    // get the item from country that matches the currentCountry
    const countryItem = country?.countries?.find((c) => {
      return c?.isoCode?.toUpperCase() === isoCode?.toUpperCase();
    });

    setShippingEst(countryItem?.shippingEstimate);
    setFreeShippingThreshold(countryItem?.freeShippingThreshold);
    setDispatch(countryItem?.dispatch);
  }, [region]);

  return <></>;
}
